import { AnyAction } from 'redux'
import { AuthorizationActions } from '../userAccount/actionNames'
import initialState from './initialState'
import { StatsActions } from './actionNames'

export default function(
  store: Readonly<IStatsStore> = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case StatsActions.SetYear:
      return {
        ...store,
        year: action.year,
      }
    case StatsActions.SetMonth:
      return {
        ...store,
        month: action.month,
      }
    case StatsActions.SetChartsType:
      return {
        ...store,
        chartType: action.chartType,
      }
    case StatsActions.SetSelectedRooms:
      return {
        ...store,
        selectedRooms: action.selectedRooms,
      }
    case StatsActions.SetStats:
      return {
        ...store,
        RevPAR: action.RevPAR,
        avgPrice: action.avgPrice,
        occupancy: action.occupancy,
        reservation: action.reservation,
      }
    case AuthorizationActions.SignOffTheAccount:
      return {
        ...initialState,
      }
  }

  return store
}

export interface IStatsStore {
  year: number
  month: number
  chartType: ChartsType
  selectedRooms: string[]
  reservation: any[][]
  occupancy: IStats[][]
  avgPrice: IStats[][]
  RevPAR: IStats[][]
}

interface IStats {
  roomId: string
  value: any
  color: string
}

export enum ChartsType {
  All = 'all',
  Selected = 'selected',
}
